import type { ProductAd } from '@/scopes/product-ads/domain/types'
import { useIntl } from '@/intl'
import { ProductAdLoading } from '@/scopes/product-ads/components/ProductAdLoading'
import { Carousel } from '@sunwebgroup/uds-ui/carousel'
import { repeat } from 'ramda'
import { ProductAdComponent } from './ProductAd'
import styles from './ProductAdsList.module.css'

interface ProductAdsListProps {
  data: ProductAd[]
  isLoading?: boolean
  type: string
}

export function ProductAdsList({ data, isLoading, type }: ProductAdsListProps) {
  const intl = useIntl()

  if (isLoading) {
    return <div className={styles.slider}>{repeat(<ProductAdLoading />, 7)}</div>
  }

  return (
    <Carousel
      hasControls
      nextButtonAriaLabel={intl.formatMessage({ id: 'next_carousel_ads' })}
      prevButtonAriaLabel={intl.formatMessage({ id: 'previous_carousel_ads' })}
    >
      {data.map(productAd => (
        <ProductAdComponent data={productAd} key={productAd.adId} componentType={type} />
      ))}
    </Carousel>
  )
}
